export default "../css/8e921d98d20d6ae79fff62f9f16fbcc5.ttf";